// extracted by mini-css-extract-plugin
export var productImage = "_p9-1";
export var viewLink = "_p9-2";
export var wishlistItem = "_p9-0";